module.exports = __webpack_public_path__ + "static/media/FamilyPayments.57bf9429.svg";